function loadCSS(cdnUrl) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cdnUrl;
    link.type = 'text/css';
    document.head.appendChild(link); // Adds the link to the document head
}

loadCSS('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.1/css/all.min.css');

const sparklyButtonContainer = document.querySelector(
  "body",
);
const sparklyButton = document.querySelector(".sparkly-button");
const sparkleAnimationDuration = 750;
const hexagonAnimationDuration = 850;
const circlesAnimationDuration = 750;

const createKeyframeCircle = ({ position: { x, y }, index, indexCenter }) => {
  const name = `circle_${index}_${indexCenter}`;
  const keyframe = `
    @keyframes ${name} {
        0% {
            transform: scale(0.5);
            background-color: var(--sparkly-button-color-one);
        }
        10% {
            opacity: 1;
        }
        20% {
            background-color: var(--sparkly-button-color-one);
        }
        30% {
            background-color: var(--sparkly-button-color-two);
        }
        40% {
            background-color: var(--sparkly-button-color-three);
        }
        50% {
            background-color: var(--sparkly-button-color-four);
        }
        60% {
            background-color: var(--sparkly-button-color-five);
        }
        70% {
            background-color: var(--sparkly-button-color-six);
        }
        80% {
            opacity: 1;
            background-color: var(--sparkly-button-color-seven);
        }
        100% {
            opacity: 0;
            transform: scale(1);
            background-color: var(--sparkly-button-color-eight);
            top: ${y}px;
            left: ${x}px;
        }
    }
    `;

  const styleElement = document.createElement("style");
  document.head.appendChild(styleElement);
  const styleSheet = styleElement.sheet;
  styleSheet.insertRule(keyframe);

  return { animationName: name, removeStyleSheet: () => styleElement.remove() };
};

const createKeyframe = ({ translation: { x, y }, index, type }) => {
  const name = `${type}_${index}`;
  const keyframe = `
    @keyframes ${name} {
        0% {
            transform: scale(0);
            color: var(--sparkly-button-color-one);
        }
        10% {
            opacity: 1;
        }
        20% {
            color: var(--sparkly-button-color-one);
        }
        30% {
            color: var(--sparkly-button-color-two);
        }
        40% {
            color: var(--sparkly-button-color-three);
        }
        50% {
            color: var(--sparkly-button-color-four);
        }
        60% {
            color: var(--sparkly-button-color-five);
        }
        70% {
            color: var(--sparkly-button-color-six);
        }
        71% {
            opacity: 1;
            transform: scale(1) translate(${x}px, ${y}px);
            color: var(--sparkly-button-color-seven);
        }
        100% {
            opacity: 0;
            transform: scale(1) translate(${x}px, ${y}px);
            color: var(--sparkly-button-color-eight);
        }
    }
    `;

  const styleElement = document.createElement("style");
  document.head.appendChild(styleElement);
  const styleSheet = styleElement.sheet;
  styleSheet.insertRule(keyframe);

  return { animationName: name, removeStyleSheet: () => styleElement.remove() };
};

const createShapeSparkle = ({ x, y, size }) => {
  const shape = document.createElement("i");
  shape.classList.add("fa-solid", "fa-star", "shape");
  shape.style.top = `${y}px`;
  shape.style.left = `${x}px`;
  shape.style.fontSize = `${size}px`;
  sparklyButtonContainer.appendChild(shape);

  return shape;
};

const createShapeHexagon = ({ x, y, size }) => {
  const shape = document.createElement("i");
  shape.classList.add("fa-solid", "fa-heart", "shape");
  shape.style.top = `${y}px`;
  shape.style.left = `${x}px`;
  shape.style.fontSize = `${size}px`;
  sparklyButtonContainer.appendChild(shape);

  return shape;
};

const generatePositionsHexagon = () => {
  const { left, top, right, bottom } = sparklyButton.getBoundingClientRect();
  const width = right - left;
  const height = bottom - top;

  const positions = [
    {
      x: left + width / 4,
      y: top + 2,
      size: 10,
      translation: { x: -5, y: -30 },
      delay: 0,
    },
    {
      x: left + 16,
      y: bottom - height / 4,
      size: 12,
      translation: { x: -20, y: 15 },
      delay: 300,
    },
    {
      x: right - 15,
      y: top - 5,
      size: 10,
      translation: { x: 20, y: -30 },
      delay: 100,
    },
  ];
  return positions;
};
const generatePositionsSparkles = () => {
  const { left, top, right, bottom } = sparklyButton.getBoundingClientRect();
  const width = right - left;
  const height = bottom - top;

  const positions = [
    {
      x: left + 15,
      y: top - 10,
      size: 17,
      translation: { x: -20, y: -25 },
      delay: 0,
    },
    {
      x: left + width / 5,
      y: bottom - 3,
      size: 14,
      translation: { x: -8, y: 5 },
      delay: 300,
    },
    {
      x: left + 5 + width / 2,
      y: bottom - 10,
      size: 12,
      translation: { x: 10, y: 20 },
      delay: 100,
    },
    {
      x: right - width / 4,
      y: top + 10,
      size: 21,
      translation: { x: 10, y: -20 },
      delay: 200,
    },
    {
      x: right - 20,
      y: bottom - 10,
      size: 13,
      translation: { x: 12, y: 30 },
      delay: 350,
    },
  ];
  return positions;
};

const createSixPointsAroundPoint = (x, y, radius, endRadius) => {
  const points = [];
  for (let i = 0; i < 6; i++) {
    const angle = (i * Math.PI) / 3;
    const point = {
      x: x + radius * Math.cos(angle),
      y: y + radius * Math.sin(angle),
      endX: x + endRadius * Math.cos(angle),
      endY: y + endRadius * Math.sin(angle),
    };
    points.push(point);
  }

  return points;
};

const createExplodingPoints = ({ x, y }, indexCenter) => {
  const surroundingPoints = createSixPointsAroundPoint(x, y, 10, 25);
  surroundingPoints.map(({ x, y, endX, endY }, index) => {
    const point = document.createElement("span");
    point.classList.add("circle", "shape");
    point.style.top = `${y}px`;
    point.style.left = `${x}px`;
    sparklyButtonContainer.appendChild(point);

    const { animationName, removeStyleSheet } = createKeyframeCircle({
      position: { x: endX, y: endY },
      index,
      indexCenter,
    });
    point.style.animationName = animationName;
    point.style.animationDuration = `${circlesAnimationDuration}ms`;
    setTimeout(() => {
      //point.remove();
      //removeStyleSheet();
    }, circlesAnimationDuration);
  });
};

const restartAnimation = (el) => {
  el.style.animationName = "none";
  void el.offsetWidth;
  el.style.animationName = "gradient";
};

sparklyButton.addEventListener("click", function () {
  restartAnimation(sparklyButton);

  const positionsSparkles = generatePositionsSparkles();
  positionsSparkles.map(({ x, y, size, translation, delay }, index) => {
    const shape = createShapeSparkle({ x, y, size });
    const { animationName, removeStyleSheet } = createKeyframe({
      translation,
      index,
      type: "spakle",
    });
    shape.style.animationName = animationName;
    shape.style.animationDelay = `${delay}ms`;
    shape.style.animationDuration = `${sparkleAnimationDuration}ms`;
    setTimeout(() => {
      shape.remove();
      removeStyleSheet();
    }, sparkleAnimationDuration + delay);
  });

  const positionsHexagon = generatePositionsHexagon();
  positionsHexagon.map(({ x, y, size, translation, delay }, index) => {
    const shape = createShapeHexagon({ x, y, size });
    const { animationName, removeStyleSheet } = createKeyframe({
      translation,
      index,
      type: "hexagon",
    });
    shape.style.animationName = animationName;
    shape.style.animationDelay = `${delay}ms`;
    shape.style.animationDuration = `${hexagonAnimationDuration}ms`;
    const endPosition = { x: x + translation.x, y: y + translation.y };
    setTimeout(() => {
      shape.remove();
      removeStyleSheet();
      createExplodingPoints(endPosition, index);
    }, delay + hexagonAnimationDuration);
  });
});
